'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var objectToString = Object.prototype.toString;

/**
 * create the fake function args array for the stringified function
 *
 * @param {number} length
 * @returns {string}
 */
var getFunctionArgs = exports.getFunctionArgs = function getFunctionArgs(length) {
  var string = '',
    index = -1;
  while (++index < length) {
    string += 'arg,';
  }
  return string.slice(0, -1);
};

/**
 * get the generic string value of the function passed
 *
 * @param {function} fn
 * @param {boolean} isGenerator=false
 * @returns {string}
 */
var toFunctionString = exports.toFunctionString = function toFunctionString(fn) {
  var isGenerator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return 'function' + (isGenerator ? '*' : '') + ' ' + (fn.name || 'anonymous') + '(' + getFunctionArgs(fn.length) + '){}';
};

/**
 * get the toString value of object
 *
 * @param {*} object
 * @returns {string}
 */
var toString = exports.toString = function toString(object) {
  return objectToString.call(object);
};